import axios from 'axios';

const singleSaloonApi = async (filterValues, langIsoCode) => {
  try {
    const url = `/Saloon/singleSaloon?saloon_id=${
      filterValues?.saloonId || ''
    }&page=${filterValues?.page || 1}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: langIsoCode
      }
    });

    return res;
  } catch (error) {
    throw error;
  }
};

export default singleSaloonApi;
